/* eslint-disable prettier/prettier */
import React from 'react';
import styles from './LearnerProgressCard.module.css';

type ProgressItem = {
	label: string;
	value: number; // %
};

type Props = {
	title: string;
	count?: number;
	data: ProgressItem[];

	width?: string;
	height?: string;

	barColor?: string;
	trackColor?: string;
};

const LearnerProgressCard: React.FC<Props> = ({
	title,
	count,
	data,
	width = '100%',
	height = 'auto',
	barColor = '#F97316', // orange
	trackColor = '#E5E7EB',
}) => {
	return (
		<div className={styles.card} style={{ width, height }}>
			{/* Header */}
			<div className={styles.header}>
				<h3>{title}</h3>
				{count !== undefined && <span>{count}</span>}
			</div>

			{/* Progress List */}
			<div className={styles.list}>
				{data.map((item, index) => (
					<div key={index} className={styles.row}>
						<div className={styles.labelRow}>
							<span className={styles.label}>{item.label}</span>
							<span className={styles.percent}>
								{item.value}%
							</span>
						</div>

						<div
							className={styles.progressTrack}
							style={{ backgroundColor: trackColor }}
						>
							<div
								className={styles.progressFill}
								style={{
									width: `${item.value}%`,
									backgroundColor: barColor,
								}}
							/>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default LearnerProgressCard;
